import { render, staticRenderFns } from "./MyCompanyGroupsNew.vue?vue&type=template&id=212e2222&"
import script from "./MyCompanyGroupsNew.vue?vue&type=script&lang=js&"
export * from "./MyCompanyGroupsNew.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports